import useSWR from 'swr';
import {fetcher, isofetch} from '@helpers/common/fetch.mjs';

export const useMediaForOneSku = (skuList, params = {}) => {
  // console.log('[useMediaForOneSku] skuList: ', skuList);
  let skulistValues = skuList?.join(',');
  skulistValues = encodeURIComponent(skulistValues);
  let apiUrl = `/api/product/media?skuList=${skulistValues}`;

  const queryString = Object.entries(params)
    ?.map(([key, value]) => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    })
    .join('&');
  if (queryString) {
    apiUrl += `&${queryString}`;
  }
  const {data, mutate, isLoading, isValidating} = useSWR(apiUrl, fetcher);

  const isLoaded = typeof data !== 'undefined';
  const isLoadedOnce = !isLoading && isLoaded;

  const updateStatuses = async (status, imageIds) => {
    const body = {
      status,
      imageIds
    };
    const data = await isofetch.post('/api/product/media/admin', body);
    await mutate();
    return data;
  };

  const rotateImage = async (imageUrl, rotateAngle) => {
    const body = {
      imageUrl,
      rotateAngle
    };
    const data = await isofetch.post('/api/product/media/rotate', body);
    await mutate();
    return data;
  };

  const images = data?.images;
  const videos = data?.videos;

  return {
    isLoading,
    isLoadedOnce,
    isValidating,
    images,
    videos,
    updateStatuses,
    rotateImage,
    mutateMedia: mutate
  };
};
